.badge {
  padding: 5px 7px;
  font-size: var(--font-size-helptext);
  line-height: 1;
  border-radius: 50px;
}

.default {
  color: var(--on-background);
  background-color: var(--badge-default-background);
}

.error {
  color: var(--badge-error-text);
  background-color: var(--badge-error-background);
}

.success {
  color: var(--badge-success-text);
  background-color: var(--badge-success-background);
}
